<template>
  <div id="app">
    <div class="app-shell">
      <TopNav :account="wallet.account" :connected="!!wallet.account" @connect="handleConnectWallet" />

      <div class="tabs" :class="{ 'tabs-single': !presaleVisible }">
        <button v-if="presaleVisible" class="tab" :class="{ active: activeTab === 'presale' }" @click="switchTab('presale')">
          🌕 预售认购
        </button>
        <button class="tab" :class="{ active: activeTab === 'mining' || !presaleVisible }" @click="switchTab('mining')">
          ⛏️ 参与燃烧
        </button>
      </div>

      <div class="page" v-if="presaleVisible && activeTab === 'presale'">
        <MintView />
      </div>
      <div class="page" v-else>
        <BurnView />
      </div>

      <SocialBar />
    </div>
  </div>
</template>

<script>
import MintView from './views/MintView.vue'
import BurnView from './views/BurnView.vue'
import TopNav from './components/TopNav.vue'
import SocialBar from './components/SocialBar.vue'
import WalletState from './state/WalletState'
import { saveRef } from './utils/utils'

export default {
  name: 'App',
  components: {
    MintView,
    BurnView,
    TopNav,
    SocialBar,
  },
  data() {
    return {
      activeTab: 'mining',
      wallet: { ...WalletState.wallet },
      presaleVisible: false,
    }
  },
  mounted() {
    saveRef()
    WalletState.init()
    WalletState.onStateChanged(this.handleWalletChanged)
  },
  beforeDestroy() {
    WalletState.removeListener(this.handleWalletChanged)
  },
  methods: {
    handleWalletChanged(wallet) {
      this.wallet = { ...wallet }
    },
    async handleConnectWallet() {
      try {
        await WalletState.connetWallet()
      } catch (error) {
        this.$notify({
          type: 'danger',
          message: error.message || 'Connect wallet failed',
          duration: 3000,
        })
      }
    },
    switchTab(tab) {
      this.activeTab = tab
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
}
</script>
<style>
#app {
  --gold: #f5c842;
  --gold-l: #ffe07a;
  --gold-d: #c8960a;
  --amber: #e8890a;
  --bg: #0c0600;
  --card: #170d00;
  --border: #3a2500;
  --surface: #201200;
  --txt: #fff5dc;
  --muted: #7a5520;
  --green: #2ecc71;
  --red: #e74c3c;
  min-height: 100vh;
  background: var(--bg);
  color: var(--txt);
}

#app::before {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background: radial-gradient(ellipse 90% 45% at 50% 0%, rgba(245, 200, 66, 0.065) 0%, transparent 60%);
}

.app-shell {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding-bottom: 92px;
}

.tabs {
  display: flex;
  background: var(--card);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 61px;
  z-index: 190;
}

.tab {
  flex: 1;
  padding: 13px 0;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  color: var(--muted);
  cursor: pointer;
  transition: color 0.2s;
  position: relative;
  border: none;
  background: none;
}

.tab.active {
  color: var(--gold);
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20%;
  right: 20%;
  height: 2px;
  background: linear-gradient(90deg, var(--gold-d), var(--gold));
  border-radius: 2px;
}

.tabs-single {
  justify-content: center;
}

.tabs-single .tab {
  flex: 0 0 100%;
  max-width: 100%;
}

.tabs-single .tab.active::after {
  left: 35%;
  right: 35%;
}

.page {
  min-height: calc(100vh - 153px);
}

.sec {
  padding: 0 16px 14px;
}

.sec-hd {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: var(--gold);
  margin-bottom: 10px;
}

.sec-hd::before {
  content: '';
  width: 3px;
  height: 14px;
  flex-shrink: 0;
  background: linear-gradient(180deg, var(--gold), var(--amber));
  border-radius: 2px;
}

.card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
}

.card-hdr,
.mint-hdr {
  background: linear-gradient(90deg, var(--surface), #2a1800);
  padding: 13px 16px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-ttl {
  font-size: 14px;
  font-weight: 700;
  color: var(--gold);
  display: flex;
  align-items: center;
  gap: 7px;
}

.tag {
  font-size: 10px;
  padding: 3px 10px;
  border-radius: 20px;
}

.tag-gold {
  color: var(--gold-l);
  background: rgba(245, 200, 66, 0.1);
  border: 1px solid var(--gold-d);
}

.tag-amber {
  color: var(--amber);
  background: rgba(232, 137, 10, 0.1);
  border: 1px solid rgba(232, 137, 10, 0.3);
}

.tag-green {
  color: var(--green);
  background: rgba(46, 204, 113, 0.1);
  border: 1px solid rgba(46, 204, 113, 0.3);
}

.hero {
  padding: 26px 20px 18px;
  text-align: center;
}

.phase-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(245, 200, 66, 0.09);
  border: 1px solid rgba(245, 200, 66, 0.22);
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 11px;
  color: var(--gold);
  letter-spacing: 1px;
  margin-bottom: 14px;
}

.phase-pill::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--red);
  animation: blink 0.9s infinite;
}

.hero-ttl,
.mine-hero-ttl {
  background: linear-gradient(135deg, #ffe07a, #f5c842 50%, #e8890a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-ttl {
  font-size: 26px;
  font-weight: 900;
  line-height: 1.25;
  margin-bottom: 6px;
}

.hero-sub {
  font-size: 12px;
  color: var(--muted);
  line-height: 1.8;
}

.mine-hero-sub {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0 auto;
  padding: 7px 14px;
  border-radius: 999px;
  border: 1px solid rgba(46, 204, 113, 0.34);
  background: linear-gradient(180deg, rgba(46, 204, 113, 0.14), rgba(46, 204, 113, 0.05));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 8px 18px rgba(46, 204, 113, 0.08);
  font-size: 11.5px;
  color: var(--green);
  line-height: 1.4;
  text-shadow: 0 0 8px rgba(46, 204, 113, 0.1);
  letter-spacing: 0.25px;
}

.mint-card,
.mine-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
}

.mint-body,
.mine-body,
.inv-body {
  padding: 16px;
}

.sale-box {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 16px;
  padding: 15px 14px;
  margin-bottom: 14px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
}

.sale-head {
  font-size: 12px;
  color: #c8b68d;
  margin-bottom: 10px;
}

.sale-head b,
.num-orbitron {
  font-family: 'Orbitron', monospace;
  font-weight: 900;
}

.sale-bar {
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.07);
  overflow: hidden;
}

.sale-fill {
  height: 100%;
  background: linear-gradient(90deg, #d7b03a, #f5d86c, #fff1ae);
  border-radius: 999px;
  transition: width 0.35s ease;
}

.calc-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.22);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.cb-l,
.mcalc-l {
  font-size: 11px;
  color: var(--muted);
}

.cb-l b,
.cb-r b,
.mcalc-l b,
.mcalc-r b,
.gs-v,
.ds-v,
.pc-v,
.claim-amt,
.ist-v {
  font-family: 'Orbitron', monospace;
}

.cb-l b {
  display: block;
  font-size: 15px;
  color: var(--txt);
  margin-bottom: 2px;
}

.cb-arr,
.mcalc-arr {
  font-size: 18px;
  color: var(--gold-d);
}

.cb-r {
  text-align: right;
}

.cb-r b {
  display: block;
  font-size: 16px;
  font-weight: 900;
  color: var(--gold);
  margin-bottom: 2px;
}

.minted-ok {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(46, 204, 113, 0.08);
  border: 1px solid rgba(46, 204, 113, 0.2);
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 14px;
  font-size: 13px;
  color: var(--green);
  font-weight: 700;
}

.main-btn,
.btn-mine,
.btn-claim,
.copy-btn {
  border: none;
  cursor: pointer;
}

.main-btn,
.btn-mine {
  width: 100%;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 900;
  padding: 15px;
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
}

.main-btn:disabled,
.btn-mine:disabled,
.btn-claim:disabled,
.copy-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-gold,
.btn-mine {
  background: linear-gradient(135deg, var(--gold), var(--amber));
  color: var(--bg);
  box-shadow: 0 5px 22px rgba(245, 200, 66, 0.32);
}

.main-hint {
  text-align: center;
  font-size: 11px;
  color: var(--muted);
  margin-top: 9px;
  line-height: 1.7;
}

.link-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.28);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 12px;
}

.link-txt {
  flex: 1;
  font-size: 11px;
  color: var(--muted);
  font-family: 'Orbitron', monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-btn {
  background: linear-gradient(135deg, var(--gold-d), var(--amber));
  border-radius: 7px;
  color: var(--bg);
  font-size: 11px;
  font-weight: 900;
  padding: 6px 12px;
  white-space: nowrap;
}

.inv-stats,
.pgrid,
.daily-row,
.gstats {
  display: grid;
  gap: 8px;
}

.inv-stats,
.pgrid,
.daily-row {
  grid-template-columns: 1fr 1fr;
}

.ist,
.pc,
.ds,
.gs {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.ist {
  padding: 12px;
  text-align: center;
}

.ist-v {
  font-size: 22px;
  font-weight: 900;
  color: var(--gold);
}

.ist-l,
.pc-l,
.pc-u,
.ds-l,
.ds-u,
.gs-l,
.claim-l,
.claim-sub {
  color: var(--muted);
}

.ist-l,
.pc-l {
  font-size: 10px;
  margin-top: 3px;
}

.ds-l {
  font-size: 10px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.pay-token-hint {
  font-size: 11px;
  color: #d06050;
  font-weight: 700;
}

.inv-flow {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  overflow: hidden;
  margin-bottom: 8px;
}

.inv-pill {
  background: rgba(245, 200, 66, 0.1);
  border: 1px solid rgba(245, 200, 66, 0.2);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 10px;
  color: var(--gold-l);
  font-family: 'Orbitron', monospace;
  white-space: nowrap;
  flex: 0 0 auto;
}

.inv-arr {
  color: var(--muted);
  font-size: 11px;
  flex: 0 0 auto;
}

.inv-inf {
  color: var(--amber);
  font-size: 12px;
  font-weight: 900;
  flex: 0 0 auto;
}

.notice {
  background: rgba(231, 76, 60, 0.06);
  border: 1px solid rgba(231, 76, 60, 0.16);
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 11px;
  color: #d06050;
  line-height: 1.9;
}

.notice b {
  color: #e07060;
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
}

.notice ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.notice li {
  position: relative;
  padding-left: 12px;
}

.notice li::before {
  content: '*';
  position: absolute;
  left: 0;
  color: var(--red);
}

.mine-hero {
  padding: 20px 16px 14px;
  text-align: center;
}

.mine-hero-ttl {
  font-size: 22px;
  font-weight: 900;
  margin-bottom: 4px;
}

.gstats {
  grid-template-columns: 1fr 1fr;
}

.gs {
  padding: 12px 8px;
  text-align: center;
}

.gs-v {
  font-size: 12px;
  font-weight: 700;
  color: var(--gold);
}

.gstats-market .gs-global .gs-v {
  font-size: 14px;
  font-weight: 900;
}

.gs-l {
  font-size: 9px;
  margin-top: 3px;
}

.gstats-market .gs-global .gs-l {
  font-size: 10px;
}

.ds {
  padding: 12px 14px;
}

.ds-v,
.pc-v {
  font-size: 16px;
  font-weight: 900;
  color: var(--gold);
}

.ds-v {
  margin-bottom: 2px;
}

.mine-body {
  padding: 16px;
}

.inp-lbl {
  font-size: 11px;
  color: var(--muted);
  margin-bottom: 7px;
}

.irow {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(180deg, rgba(17, 28, 12, 0.98), rgba(13, 19, 10, 0.98));
  border: 1px solid rgba(46, 204, 113, 0.58);
  border-radius: 12px;
  padding: 0 14px;
  margin-bottom: 12px;
  transition: border-color 0.2s;
  box-shadow: inset 0 1px 0 rgba(123, 255, 174, 0.08), 0 0 0 1px rgba(46, 204, 113, 0.18);
}

.irow:focus-within {
  border-color: #55e58e;
  box-shadow: inset 0 1px 0 rgba(123, 255, 174, 0.14), 0 0 0 2px rgba(46, 204, 113, 0.18);
}

.irow > span:first-child {
  color: #55e58e;
  text-shadow: 0 0 10px rgba(46, 204, 113, 0.12);
}

.irow input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: var(--txt);
  font-size: 20px;
  font-family: 'Orbitron', monospace;
  font-weight: 700;
  padding: 13px 0;
  min-width: 0;
}

.irow input::placeholder {
  color: rgba(123, 255, 174, 0.46);
  font-size: 14px;
  font-weight: 400;
}


.irow-unit {
  font-size: 11px;
  color: #7af2ab;
  border-left: 1px solid rgba(46, 204, 113, 0.22);
  padding-left: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

.mcalc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(245, 200, 66, 0.06);
  border: 1px solid rgba(245, 200, 66, 0.14);
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 14px;
}

.mcalc-l b {
  display: block;
  font-size: 14px;
  color: var(--txt);
  margin-bottom: 1px;
}

.mcalc-r {
  text-align: right;
}

.mcalc-r b {
  display: block;
  font-size: 15px;
  font-weight: 900;
  color: var(--gold);
}

.mcalc-r small {
  font-size: 10px;
  color: var(--green);
}

.calc-note {
  margin: -4px 2px 12px;
  font-size: 11px;
  line-height: 1.5;
  color: rgba(245, 200, 66, 0.78);
}

.pc {
  padding: 13px;
}

.pc-ico {
  font-size: 16px;
  margin-bottom: 5px;
}

.claim-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 14px 16px;
}

.claim-info {
  flex: 1;
}

.claim-l {
  font-size: 11px;
  margin-bottom: 2px;
}

.claim-amt {
  font-size: 20px;
  font-weight: 900;
  color: var(--green);
}

.btn-claim {
  background: linear-gradient(135deg, var(--green), #27ae60);
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
  padding: 11px 18px;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(46, 204, 113, 0.28);
}


.inv-stats-presale {
  margin-bottom: 12px;
}

.inv-stats-presale .ist {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 14px 12px;
  min-height: 84px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.invite-rule-card {
  background: rgba(245, 200, 66, 0.06);
  border: 1px solid rgba(245, 200, 66, 0.16);
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 10px;
}

.invite-rule-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.invite-rule-desc {
  font-size: 11px;
  color: var(--muted);
  line-height: 1.7;
}

.invite-progress-card {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
}

.invite-progress-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.invite-progress-label {
  font-size: 11px;
  color: var(--muted);
}

.invite-progress-value {
  font-size: 11px;
  color: var(--gold);
  font-family: 'Orbitron', monospace;
}

.invite-progress-bar {
  height: 6px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--border);
}

.invite-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--gold-d), var(--gold));
  border-radius: 6px;
  transition: width 0.6s ease;
}

.gstats-market {
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.market-price-card {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.daily-row-market {
  gap: 8px;
}
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

@media (max-width: 420px) {
  .app-shell {
    padding-bottom: 88px;
  }

  .tab {
    font-size: 12px;
  }
}
</style>

